module.exports = __webpack_public_path__ + "static/img/GetStarted_WhatType_1440x985.77812e5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/GetStarted_WhatType_1440x985.jpg
// module id = 1543
// module chunks = 5